import { PaymentsCompanyId } from './payments-company-id';

/**
 * El `id_company` de RUTA de Payments que mandan las pantallas de E-commerce. TypeScript puro.
 *
 * ⚠️ NO se deduce de la entidad activa del selector (decisión del humano 2026-10-16): esa
 * entidad es de BANCA (`company/balances/`) y el login no trae ningún id que la enlace con
 * su comercio. El valor sale SOLO del catálogo de comercios del usuario
 * (`payments_company.id_company` de `GET /api/gestor/services/`, o
 * `resolvePaymentsCompanyId` sobre `GET /api/v1/payments/companies/`).
 *
 * - `ok`: exactamente un comercio ⇒ su valor de ruta, que se manda SIEMPRE.
 * - `unresolved`: ninguno ⇒ falla CERRADA ("sin acceso"), sin petición.
 * - `multiple`: dos o más ⇒ aviso "elige uno", sin petición (el selector es otra feature).
 */
export type PaymentsRouteCompany =
  | { readonly kind: 'ok'; readonly id: PaymentsCompanyId }
  | { readonly kind: 'unresolved' }
  | { readonly kind: 'multiple' };

/** Un comercio de Payments del alcance de la sesión, con su valor de RUTA ya resuelto. */
export interface PaymentsSessionCompany {
  readonly routeId: PaymentsCompanyId;
  readonly name: string | null;
}

/** El catálogo ya viene deduplicado por `routeId`. */
export function resolvePaymentsRouteCompany(catalog: readonly PaymentsSessionCompany[]): PaymentsRouteCompany {
  if (catalog.length === 1) return { kind: 'ok', id: catalog[0].routeId };
  if (catalog.length === 0) return { kind: 'unresolved' };
  return { kind: 'multiple' };
}

/** Deduplica por `routeId` conservando el primero. */
export function dedupePaymentsSessionCompanies(
  lista: readonly PaymentsSessionCompany[],
): PaymentsSessionCompany[] {
  const vistos = new Map<string, PaymentsSessionCompany>();
  for (const c of lista) {
    const llave = String(c.routeId);
    if (!vistos.has(llave)) vistos.set(llave, c);
  }
  return [...vistos.values()];
}
